(() => {
'use strict';
const destinations={"/policies/privacy-policy":"https://ecoscape.co.uk/cookie-privacy-policy/","/collections/all":"https://ecoscape.co.uk/outdoor-accessories/"};
function updateLink(link){
 let url;try{url=new URL(link.href,location.origin);}catch{return;}
 const explicit=destinations[url.href]||((url.origin===location.origin)?destinations[url.pathname]:null);
 if(explicit){link.href=explicit;return;}
}
function updateWithin(root){
 if(root.matches?.('a[href]'))updateLink(root);
 root.querySelectorAll?.('a[href]').forEach(updateLink);
}
function init(){
 updateWithin(document);
 document.addEventListener('click',event=>{const link=event.target.closest?.('a[href]');if(link)updateLink(link);},true);
 const observer=new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)updateWithin(node);})));
 observer.observe(document.body,{childList:true,subtree:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

